import Scene from "./Scene";
import ColorPicker from "../ui/ColorPicker";
import common from "../common";
import SplineWalker from "../utils/SplineWalker";

export default class TestScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        const bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.width = common.STAGE_WIDTH;
        bg.height = common.STAGE_HEIGHT;
        bg.tint = 0xd3d3d3;
        this.addChild(bg);

        const picker = new ColorPicker();
        picker.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(picker);

        this._walker = new SplineWalker(P3.assets.json("curves_01"), 1);
    }

    resize() {
        super.resize();
    }

    animateIn() {
        this._walker.playing = true;
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
        this._walker.update(dt);
    }

    end() {

    }

}